import { ProductType } from "../enums/product-type";
import { ClickEcommerceTrackingData } from "./click-ecommerce-tracking-data.class";
export class PartnerIncentiveClickEcommerceTrackingData extends ClickEcommerceTrackingData {
    productId;
    listPageType;
    listEntityType;
    listName;
    organisationId;
    listPosition;
    constructor(productId, listPageType, listEntityType, listName, organisationId, listPosition) {
        super(productId, listPageType, listName, organisationId, undefined, undefined, listPosition, undefined, undefined, ProductType.PARTNER);
        this.productId = productId;
        this.listPageType = listPageType;
        this.listEntityType = listEntityType;
        this.listName = listName;
        this.organisationId = organisationId;
        this.listPosition = listPosition;
    }
    getTrackingContext() {
        return {
            organisationId: this.getOrganisationId(),
            studyId: undefined,
            scholarshipId: undefined,
            bodyId: undefined,
            premiumnessLevel: this.premium?.toString() ?? '',
            price: undefined,
            position: this.listPosition,
            currency: undefined
        };
    }
}
